module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JLt1Gh/tc-custom/9781426894299.jpg?1701515749224",
      "alt": "This image is the cover for the book Max and Finn, Men of Smithfield"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Max and Finn, Men of Smithfield\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When I walked out of his office after the hottest sex of my life, I thought I'd left Max Douglas behind me foreveralong with my favorite argyle socks and my self-respect. The last thing I need is the too-serious, too-sexy former Marine living across the hall from me while he acts as a bodyguard for one of my students. Especially since he fired me from my job tutoring his brother"), _c('i', [_vm._v("after")]), _vm._v(" we hooked up."), _c('br'), _c('br'), _vm._v("I shouldn't want him. I should despise him after the way he treated me. But he's exactly my type: older, experienced, in controland it's obvious the lust is still mutual. While I may not be able to keep our relationship strictly professional, I'm determined to keep it purely physical. But when the stalker threats escalate, it looks like Max is going to be sticking around the school for a whileand the more I get to know him, the more I'm in danger of losing my heart."), _c('br'), _c('br'), _c('i', [_vm._v("Previously published, newly revised by author.")]), _c('br'), _c('br'), _vm._v("39,000 words")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      L.B. Gregg\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0